/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/naming-convention */
import {useMutation} from '@apollo/client';
import CircularProgress from '@material-ui/core/CircularProgress';
import {
  ResultInput,
  Standing,
  // TableWorker,
} from 'packages/common-types/schema-types';
import {cleanTablesTypenames} from 'packages/common-utils/helpers';
import {SUCCESS_SAVE_TOAST} from 'packages/constants/constants';
import ConfirmSave from 'packages/dialogs/ConfirmSave';
import {SAVE_RESULT} from 'packages/graphql/v2/mutations';
import {GET_NUMBER_OF_ROUNDS} from 'packages/graphql/v2/queries';
import useAppDispatch from 'packages/hooks/use-app-dispatch';
import useAppSelector from 'packages/hooks/use-app-selector';
import {useModal} from 'packages/hooks/use-modal';
import {memo} from 'react';
import {selectTournament, triggerToast} from 'redux/features/app-slice';
import {
  selectGeneratedRound,
  // selectRoundMetadata,
  setGeneratedRound,
  setRoundMetadataKey,
} from 'redux/features/round-slice';
import StyledButton from '../../common-ui/StyledButton';

type SaveResultVars = {
  tournamentId: string;
  round: ResultInput[];
};

type SaveResultData = {
  saveResult: Standing;
};

const SaveRound = memo(() => {
  const dispatch = useAppDispatch();
  const selectedTournament = useAppSelector(selectTournament);
  const generatedRound = useAppSelector(selectGeneratedRound);
  // const {currentRound} = useAppSelector(selectRoundMetadata);
  const [save, {loading}] = useMutation<SaveResultData, SaveResultVars>(
    SAVE_RESULT
  );
  const {toggle: toggleConfirm, modalOpen: confirmOpen} = useModal();

  const handleSaveRound = async () => {
    const cleanedTables = cleanTablesTypenames(generatedRound?.tables);

    const canSubmit = generatedRound?.tables?.every(
      (elem) => elem.result.competitorOne && elem.result.competitorTwo
    );

    if (canSubmit) {
      const results = cleanedTables.map(
        ({competitorOne, competitorTwo, result, tableNumber}) => {
          const nameCompetitorsOne = competitorOne
            .map(({members}) => {
              return members.map(({fullName}) => fullName);
            })
            .join();
          const indexCompetitorOne = competitorOne.map(({groupNumber}) =>
            Number(groupNumber)
          );
          const nameCompetitorsTwo = competitorTwo
            .map(({members}) => {
              return members.map(({fullName}) => fullName);
            })
            .join();
          const indexCompetitorTwo = competitorTwo.map(({groupNumber}) =>
            Number(groupNumber)
          );
          return {
            tableNumber: Number(tableNumber),
            competitorOne: {
              name: nameCompetitorsOne,
              result: result.competitorOne,
              index: indexCompetitorOne,
            },
            competitorTwo: {
              name: nameCompetitorsTwo,
              result: result.competitorTwo,
              index: indexCompetitorTwo,
            },
          };
        }
      );
      try {
        console.log('RESULTS => ', results);
        const result = await save({
          variables: {
            tournamentId: selectedTournament?._id,
            round: results,
          },
          refetchQueries: [
            {
              query: GET_NUMBER_OF_ROUNDS,
              variables: {
                tournamentId: selectedTournament?._id,
              },
            },
          ],
        });
        if (result?.data) {
          dispatch(setRoundMetadataKey({key: 'saved', value: false}));
          dispatch(setGeneratedRound(null));
          dispatch(triggerToast(SUCCESS_SAVE_TOAST));
        }
        toggleConfirm();
      } catch (error) {
        console.error(
          '🚀 ~ file: SaveRound.tsx ~ line 79 ~ handleSaveRound ~ error',
          error
        );
      }
    }
  };

  if (!generatedRound) return null;

  return (
    <>
      <ConfirmSave
        loading={loading}
        onSaveAndConfirm={handleSaveRound}
        toggle={toggleConfirm}
        modalOpen={confirmOpen}
      />
      <StyledButton
        disabled={!selectedTournament || loading}
        disableElevation
        onClick={toggleConfirm}
      >
        {loading ? <CircularProgress /> : 'Guardar'}
      </StyledButton>
    </>
  );
});

SaveRound.displayName = 'SaveRound';

export default SaveRound;
